import {
    addToChainAfter,
    ApiHandlerDiscreteParameter,
    HasOnError,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { UpdateQuoteApiParameter } from "@insite/client-framework/Services/QuoteService";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Pages/RfqQuoteDetails/Handlers/SubmitQuote";
import { QuoteModel } from "@insite/client-framework/Types/ApiModels";

export interface UpdateQuoteApiParameterExtended extends UpdateQuoteApiParameter {
    properties: any;
}

type HandlerType = ApiHandlerDiscreteParameter<
    {
        quote: QuoteModel;
    } & HasOnSuccess &
        HasOnError<string>,
    UpdateQuoteApiParameterExtended,
    QuoteModel
>;

export const ExtendedPopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        ...props.apiParameter,
        jobName: `isSalesOnly:${props.parameter.quote.properties.isSaleOnly}`,
    };
};

addToChainAfter(chain, PopulateApiParameter, ExtendedPopulateApiParameter);
